import { ITimeFrame } from 'apis/types';
import { parseBusinessTimeToMinutes } from 'utils/serverTime';

export interface LunchTimeRange {
  startMinute: number;
  endMinute: number;
}

const parseTimeFrameBoundary = (value: string, boundary: 'start' | 'end'): number | null => {
  if (boundary === 'start' && value === 'Open') return Number.NEGATIVE_INFINITY;
  if (boundary === 'end' && value === 'Close') return Number.POSITIVE_INFINITY;
  return parseBusinessTimeToMinutes(value);
};

export const getLunchTimeRanges = (timeFrames: ITimeFrame[], lunchFrameIds: string[]): LunchTimeRange[] => {
  const lunchFrameIdSet = new Set(lunchFrameIds);

  return timeFrames.reduce<LunchTimeRange[]>((ranges, timeFrame) => {
    if (!lunchFrameIdSet.has(timeFrame.time_frame_id)) return ranges;

    const startMinute = parseTimeFrameBoundary(timeFrame.start, 'start');
    const endMinute = parseTimeFrameBoundary(timeFrame.end, 'end');

    if (startMinute !== null && endMinute !== null && startMinute < endMinute) {
      ranges.push({ startMinute, endMinute });
    }

    return ranges;
  }, []);
};

export const isLunchTime = (businessMinute: number, timeFrames: ITimeFrame[], lunchFrameIds: string[]): boolean => {
  if (!Number.isFinite(businessMinute)) return false;

  return getLunchTimeRanges(timeFrames, lunchFrameIds).some(
    ({ startMinute, endMinute }) => startMinute <= businessMinute && businessMinute <= endMinute
  );
};
